// extracted by mini-css-extract-plugin
module.exports = {"block":"mirrorlink_block__1tRSg"};